function VirginIslands({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_2543)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#FCFCFC"/>
  <path d="M18.7174 11.1783C18.7174 9.67756 17.5008 8.46094 16 8.46094C14.4991 8.46094 13.2825 9.67756 13.2825 11.1783H7.30432C7.30432 12.6559 8.59145 13.8538 10.069 13.8538H9.98001C9.98001 15.3315 11.1778 16.5295 12.6556 16.5295C12.6556 17.8378 13.5952 18.9249 14.8361 19.1573L14.8292 19.1729H17.1708L17.1638 19.1573C18.4048 18.9248 19.3444 17.8377 19.3444 16.5295C20.8221 16.5295 22.02 15.3315 22.02 13.8538H21.9308C23.4084 13.8538 24.6956 12.6559 24.6956 11.1783H18.7174Z" fill="#FFDA44"/>
  <path d="M14.8054 18.8955L13.1205 22.6994C14.0095 23.0608 14.9812 23.2617 16 23.2617C17.0188 23.2617 17.9905 23.0609 18.8794 22.6994L17.1946 18.8955H14.8054Z" fill="#FFDA44"/>
  <path d="M12.5217 12.5146V17.1953C12.5217 19.8577 16 20.6736 16 20.6736C16 20.6736 19.4782 19.8577 19.4782 17.1953V12.5146H12.5217Z" fill="#F0F0F0"/>
  <path d="M3.87992 16.1123L5.7611 21.3738L7.62273 16.1123H9.04348L6.32935 23.0688H5.19279L2.45923 16.1123H3.87992Z" fill="#338AF3"/>
  <path d="M25.7391 23.0688V16.1123H27.0912V23.0688H25.7391Z" fill="#338AF3"/>
  <path d="M13.9131 14.0254V19.6975C14.3913 20.0495 14.9058 20.2915 15.3044 20.4465V14.0254H13.9131Z" fill="#D80027"/>
  <path d="M18.087 14.0254V19.6975C17.6088 20.0495 17.0943 20.2915 16.6957 20.4465V14.0254H18.087Z" fill="#D80027"/>
  <path d="M12.5217 12.5137H19.4782V14.7209H12.5217V12.5137Z" fill="#0052B4"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default VirginIslands;
